
export default {
  async mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
};
